import React, { FC, useState } from 'react'
import styles from 'styles/components/calendar.module.scss'
import { RevenueCalendar, RevenueCalendarLabel, RevenueArrowButton } from 'components/Calendar'
import { Spacer } from 'components/Utility'
import { format, isSameMonth, isSameDay } from 'date-fns'
import { Accordion, AccordionItem, AccordionWrapper } from 'components/Accordion'
import { useToggleBoolean } from 'hooks/form'

type Props = {
  accountingType: 'order' | 'deliver'
  currentMonth: Date
  startMonth: Date
  endMonth: Date
  startDate: Date
  endDate: Date
  selectDate: (date: Date) => void
  selectCurrentMonth: (date: Date) => void
  updatePeriod: (start: Date, end: Date) => void
}

const RevenueCalendarContainer: FC<Props> = (props) => {
  const { accountingType, currentMonth, startMonth, endMonth, startDate, endDate, selectCurrentMonth, selectDate } =
    props

  const [isExpand, setIsExpand] = useState<boolean>(false)
  const handleExpand = useToggleBoolean(setIsExpand)

  return (
    <AccordionWrapper>
      <Accordion
        align={isSameDay(startDate, endDate) ? 'center' : 'left'}
        label={
          isSameDay(startDate, endDate)
            ? format(startDate, 'yyyy年M月d日')
            : `${format(startDate, 'yyyy年M月d日')}-${format(endDate, 'yyyy年M月d日')}`
        }
        handleExpand={handleExpand}
        iconPath={'/icon/blue/calendar.svg'}
        isExpand={isExpand}
        size={'small'}
      >
        <AccordionItem>
          <Spacer size={16} />
          <div className={styles.calendar__monthly__header}>
            <RevenueArrowButton
              currentMonth={currentMonth}
              selectCurrentMonth={selectCurrentMonth}
              label={'前月'}
              type={'prev'}
            />
            <RevenueCalendarLabel startMonth={startMonth} endMonth={endMonth} />
            {!isSameMonth(currentMonth, new Date()) && (
              <RevenueArrowButton
                currentMonth={currentMonth}
                selectCurrentMonth={selectCurrentMonth}
                label={'翌月'}
                type={'next'}
              />
            )}
          </div>
          <Spacer size={16} />
          <RevenueCalendar
            accountingType={accountingType}
            selectedStartDate={startDate}
            selectedEndDate={endDate}
            startMonth={startMonth}
            endMonth={endMonth}
            selectDate={selectDate}
          />
          <Spacer size={16} />
        </AccordionItem>
      </Accordion>
    </AccordionWrapper>
  )
}

export default RevenueCalendarContainer
